// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6703213a] .el-drawer__header {\n  border-bottom: none;\n}\n.mbl-drawer[data-v-6703213a] {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.mbl-drawer .mbl-info[data-v-6703213a] {\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-radius: 0;\n}\n.mbl-drawer .mbl-info-body[data-v-6703213a] {\n  padding: 20px;\n  flex: 1;\n  overflow: auto;\n}\n.mbl-drawer .info-label[data-v-6703213a] {\n  color: #666;\n}\n", ""]);
// Exports
module.exports = exports;
